<!-- 媒体列表 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">媒体列表</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;">
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 用户登录名 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.platform_name}}
				</div>
				<!-- 操作 -->
				<div @click="editTable(index,item.id)" class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					编辑
				</div>
			</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange" />
		
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">媒体平台名称</div>
					
				<a-input v-model="x_platform_name" placeholder="请输入" style="width: 240px;"  />
			</div>
			
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { mediaPlatformList, mediaPlatformAdd, mediaPlatformEdit } from '@/request/api'
export default {
	name: 'mediaList_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:120, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"媒体名称", width:200, type:"name", },
				{title:"操作", width:200, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false,
			
			r_page: 1,
			table_total: 0,
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_platform_name:"", // 新增/编辑的媒体平台名称
			x_id:"",
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		that.searchButton()
		
	},
	methods:{
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			mediaPlatformList({page: that.r_page}).then(res=>{
				console.log("列表",res.data.data);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			this.drawer_title = "新增"
			this.visible = true
		},
		// 编辑
		editTable(index,e){
			let that = this
			this.drawer_title = "编辑"
			this.x_id = e
			this.visible = true
		},
		// 新增/编辑
		addRequest(){
			let that = this
			if(!that.x_platform_name){
				that.add_form_hint = "请填写内容"
			}
			else {
				that.add_button_loading = true
				if(that.drawer_title == "新增"){
					mediaPlatformAdd({
						platform_name: that.x_platform_name
					}).then(res=>{
						console.log("新增",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				else if(that.drawer_title == "编辑"){
					mediaPlatformEdit({
						platform_name: that.x_platform_name,
						id: that.x_id
					}).then(res=>{
						console.log("编辑",res);
						that.add_button_loading = false
						if(res.data.code == 0){
							that.onCloseDrawer()
							that.$message.success('操作成功');
							that.searchButton()
						}
						else {
							that.$message.error(res.data.msg || "请求失败");
						}
					})
				}
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			
			this.visible = false
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton()
		}
	}
}	
</script>

<style scoped>

</style>